import { appApiRoutes } from '@riskbase/types/http/appApi';
import type { RouteResponse } from 'types/RequestRoute';

export type TasksAssignedFilter = {
  organisations: string[];
  properties: string[];
  search: string;
};

export type TasksAssignedFilterOptions = RouteResponse<
  typeof appApiRoutes.tasks.getFilterOptions
>;

export const TasksAssignedDefaultFilter: TasksAssignedFilter = {
  organisations: [],
  properties: [],
  search: '',
};

export const TasksAssignedDefaultFilterOptions: TasksAssignedFilterOptions = {
  organisationRequired: false,
  organisations: [],
  properties: [],
};

export type TasksListResponse = RouteResponse<typeof appApiRoutes.tasks.get>;
export type TaskListItem = TasksListResponse['data'][number];
export type TaskDueGroup = TasksListResponse['included']['dueGroups'][number];

export type TaskDetailsResponse = RouteResponse<
  typeof appApiRoutes.tasks.getDetails
>;

export type TaskDetailsState = {
  isLoading: boolean;
  id: string | null;
  item: TaskDetailsResponse | null;
  error: string | null;
};

export type TasksAssignedStore = {
  items: TaskListItem[];
  selectedId: string | null;
  dueGroups: TaskDueGroup[];
  isLoading: boolean;
  isLoaded: boolean;
  filter: TasksAssignedFilter;
  filterOptions: TasksAssignedFilterOptions;
  filterOptionsDraft: TasksAssignedFilterOptions | null;
  filterOptionsLoadStatus: null | 'loading' | 'loaded' | 'error';
  error?: string;
  taskDetails: TaskDetailsState;
};

export type TaskStore = {
  tasksAssigned: TasksAssignedStore;
};
